import { render, staticRenderFns } from "./WithFooter.vue?vue&type=template&id=bc401166&"
import script from "./WithFooter.vue?vue&type=script&lang=js&"
export * from "./WithFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports